import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Alert,
  AlertTitle,
  Typography,
  Grid,
  CircularProgress,
  Tab,
  Tabs,
  Button,
  Card,
  Paper,
  CardContent,
} from "@mui/material";
import "./cards.css";
import WeeklyDetails from "./details_im";
import SpendDetails from "./details_spend";
import NWEADetails from "./details_nwea";
import GradesDetails from "./details_grades";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import Calculate from "@mui/icons-material/Calculate";
import Savings from "@mui/icons-material/Savings";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import DailyEarnDetails from "./details_daily_2024";
import { Grading } from "@mui/icons-material";

export default function TabbedInterface(props) {
  //console.log("props cards" , props)
  const [studentUniqueId, setStudentUniqueId] = React.useState(null);
  const [studentDataByDay, setStudentDataByDay] = React.useState([]);
  const [edTechData, setEdTechData] = React.useState([]);
  const [nweaData, setNWEAdata] = React.useState([]);
  const [DirectRewardsData, setDirectRewardsData] = React.useState([]);
  
  const config = {
    apiKey: "AIzaSyDlXuLrebp7QQaX2i7Sagtmi3z-ZLihEbg",
    authDomain: "epic-store-intrinsic.firebaseapp.com",
    projectId: "epic-store-intrinsic",
    storageBucket: "epic-store-intrinsic.appspot.com",
    messagingSenderId: "411861662359",
    appId: "1:411861662359:web:0d9322c8c1093e841007d2",
    measurementId: "G-S9MKBDGDWL",
  };

  const app = initializeApp(config);
  const functions = getFunctions(app);
  const getStudentData = httpsCallable(functions, "getStudentData");

  const [loading, setLoading] = React.useState(true);
  const [value, setValue] = React.useState("store");

  const handleChangeTab = (event, newValue) => {
    //console.log(newValue);
    firebase.analytics().logEvent("page_view", {
      page_title: newValue,
    });
    setValue(newValue);
  };

  React.useEffect(() => {
    getStudentData({
      email: props.student_email,
      //id: studentUniqueId
    })
      .then((result) => {
        //console.log("getstudentdata has three components", result[0])
        //[0] data by day, [1] ed tech data, [2] nwea data",result.data)
        //console.log("student data by day results", result.data[0])
        //console.log("direct rewards", result.data[3])
        setStudentDataByDay(result.data[0]);
        setStudentUniqueId(
          !result.data[1][0] ? null : result.data[1][0].student_unique_id
        );
/*         console.log(
          "logging user",
          !result.data[1][0] || props.admin
            ? props.user.email.split("@")[0]
            : result.data[1][0].student_unique_id
        ); */
        firebase
          .analytics()
          .setUserId(
            !result.data[1][0] || props.admin
              ? props.user.email.split("@")[0]
              : result.data[1][0].student_unique_id
          );
         setEdTechData(
          !result.data[1]
            ? []
            : result.data[1]
        );
        setNWEAdata(result.data[2]);
        //if(result.data[3].length >= 2, console.log("direct reward data",result.data[3]), null)
        setDirectRewardsData(result.data[3])
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function simpleName(str) {
    //console.log(str, str.split(' '))
    const arr = str.split(" ");
    if (arr.length > 1) {
      return arr[0];
    }
    return arr[0];
  }

  return loading ? (
    <div >
      <CircularProgress />
    </div>
  ) : studentDataByDay.length === 0 && !props.admin ? (
    <Alert
      severity="info"
      variant="filled"
    >
      <AlertTitle>
        {props.language === "english"
          ? `EPIC Store is not available for the logged in user.
                        If this is an error, use the feedback form to report the error.`
          : `EPIC tienda no está disponible para el usuario que ha iniciado sesión.
                    Si se trata de un error, utilice el formulario de comentarios para informar el error.`}
      </AlertTitle>
    </Alert>
  ) : studentDataByDay.length === 0 && props.admin ? (
    <Alert
      severity="info"
      variant="filled"
      style={{
        marginLeft: "10%",
        marginRight: "10%",
      }}
    >
      <AlertTitle>{"Refresh the page"}</AlertTitle>
    </Alert>
  ) : (
    <Paper elevation={3}>
      <Card>
        <CardContent>
          <Tabs
            centered
            value={value}
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
            //textColor="primary"
            indicatorColor="primary"
            //style={{border:1}}
          >
            
            <Tab
              icon={<Savings />}
              value="daily"
              disabled
              label={simpleName(
                studentDataByDay[0].student_reference.student_display_name.split(
                  ", "
                )[1]
              ).concat(
                " ",
                studentDataByDay[0].student_reference.student_display_name.split(
                  ","
                )[0][0]
                ,
                "."
              )}
              wrapped
            />
            {/*
            {(
              <Tab icon={<Calculate />} 
                value="weekly" 
                label={`${edTechData[0].edtech_points? edTechData[0].edtech_points: 0} IM points`} />
            )}

                         {studentDataByDay[0].student_reference.school_name ===
            "Belmont MS" ? (
              <Tab icon={<EmojiEventsIcon />} value="nwea" label={"BONUS"} />
            ) : null} 
                <Tab icon={<Grading />} value="grades" label="Grades" /> 
            */}
             <Tab
              icon={<ShoppingCartRoundedIcon />}
              value="store"
              label={
                 `${edTechData[0].total_points? edTechData[0].total_points + ' points': ''}`
                    }
            /> 
            
          </Tabs>
          <TabPanel value={value} index="daily">
            <DailyEarnDetails
              parentEmails={props.parentEmails}
              language={props.language}
              studentDataByDay={studentDataByDay}
            />
          </TabPanel>
           <TabPanel value={value} index="weekly">
            <WeeklyDetails
              language={props.language}
              student_unique_id={studentUniqueId}
              student_grade_level={
                studentDataByDay[0].student_reference.grade_level
              }
              edTechData={edTechData ? edTechData : []}
              studentDataByDay={studentDataByDay}
            />
          </TabPanel>
          {/*
          <TabPanel value={value} index="nwea">
            <NWEADetails
              language={props.language}
              math_eoy_goal={parseInt(
                nweaData
                  .filter(
                    (x) =>
                      x.subject === "Mathematics" && x.testing_term === "Fall"
                  )
                  .map((x) => x.typical_growth_target)[0]
              )}
              reading_eoy_goal={parseInt(
                nweaData
                  .filter(
                    (x) =>
                      x.subject === "Language Arts" && x.testing_term === "Fall"
                  )
                  .map((x) => x.typical_growth_target)[0]
              )}
              math_fall_rit={parseInt(
                nweaData
                  .filter(
                    (x) =>
                      x.subject === "Mathematics" && x.testing_term === "Fall"
                  )
                  .map((x) => x.test_rit_score)[0]
              )}
              reading_fall_rit={parseInt(
                nweaData
                  .filter(
                    (x) =>
                      x.subject === "Language Arts" && x.testing_term === "Fall"
                  )
                  .map((x) => x.test_rit_score)[0]
              )}
              math_spring_rit={parseInt(
                nweaData
                  .filter(
                    (x) =>
                      x.subject === "Mathematics" && x.testing_term === "Spring"
                  )
                  .map((x) => x.test_rit_score)[0]
              )}
              reading_spring_rit={parseInt(
                nweaData
                  .filter(
                    (x) =>
                      x.subject === "Language Arts" &&
                      x.testing_term === "Spring"
                  )
                  .map((x) => x.test_rit_score)[0]
              )}
              math_winter_rit={parseInt(
                nweaData
                  .filter(
                    (x) =>
                      x.subject === "Mathematics" && x.testing_term === "Winter"
                  )
                  .map((x) => x.test_rit_score)[0]
              )}
              reading_winter_rit={parseInt(
                nweaData
                  .filter(
                    (x) =>
                      x.subject === "Language Arts" &&
                      x.testing_term === "Winter"
                  )
                  .map((x) => x.test_rit_score)[0]
              )}
              dec_6_attendance={
                studentDataByDay
                  .filter((x) => x.instructional_day.value === "2022-12-06")
                  .map((x) => x.school_attendance_event_category_descriptor)[0]
              }
              dec_7_attendance={
                studentDataByDay
                  .filter((x) => x.instructional_day.value === "2022-12-07")
                  .map((x) => x.school_attendance_event_category_descriptor)[0]
              }
              mar_21_attendance={
                studentDataByDay
                  .filter((x) => x.instructional_day.value === "2023-03-21")
                  .map((x) => x.school_attendance_event_category_descriptor)[0]
              }
              mar_22_attendance={
                studentDataByDay
                  .filter((x) => x.instructional_day.value === "2023-03-22")
                  .map((x) => x.school_attendance_event_category_descriptor)[0]
              }
              mar_23_attendance={
                studentDataByDay
                  .filter((x) => x.instructional_day.value === "2023-03-23")
                  .map((x) => x.school_attendance_event_category_descriptor)[0]
              }
              april_13_attendance={
                studentDataByDay
                  .filter((x) => x.instructional_day.value === "2023-04-13")
                  .map((x) => x.school_attendance_event_category_descriptor)[0]
              }
              may_23_attendance={
                studentDataByDay
                  .filter((x) => x.instructional_day.value === "2023-05-23")
                  .map((x) => x.school_attendance_event_category_descriptor)[0]
              }
              may_24_attendance={
                studentDataByDay
                  .filter((x) => x.instructional_day.value === "2023-05-24")
                  .map((x) => x.school_attendance_event_category_descriptor)[0]
              }
            />
          </TabPanel>
          */}
          
          <TabPanel value={value} index="store">
            <SpendDetails
              language={props.language}
              student_unique_id={studentUniqueId}
              studentDataByDay={studentDataByDay}
              admin={props.admin}
              direct_rewards_data={DirectRewardsData}
              direct_rewards_dressdown_earned={DirectRewardsData.map(x=>x.Passes).reduce((a,b)=>{return a+b},0)}
              //advisoryData={props.advisoryData}
            />
          </TabPanel>
          {/*
          <TabPanel value={value} index="grades">
            <GradesDetails
              language={props.language}
              student_unique_id={studentUniqueId}
              admin={props.admin}
            />
          </TabPanel> */}
        </CardContent>
      </Card>
    </Paper>
  );
}
